import { useState } from 'react'
import { useTransactionDetailsApi } from '../../../../../../api/transaction-detail-api'
import { TransactionDetails } from '../../../../../../types'

export const useTransactionDetails = (): {
  detailsLoading: boolean
  detailsError: boolean
  getTransactionDetails: (transactionId: string) => Promise<void>
  transactionDetail: TransactionDetails
} => {
  const { fetchTransactionDetails } = useTransactionDetailsApi()
  const [transactionDetail, setTransactionDetail] =
    useState<TransactionDetails>({
      checkImageUrl: '',
      checkTransactionIndicator: false,
      comment: '',
      earlyWithdrawalPenaltyApplied: 0,
      eligibilityStatus: '',
      transactionAmountPvtEncrypt: 0,
      transactionBalancePvtEncrypt: 0,
      transactionCheckNumberPvtEncrypt: '',
      transactionCode: '',
      transactionDescription: '',
      transactionId: '',
      transactionPostingDate: '',
      transactionSequenceNumber: 0,
      transactionStatus: '',
      transactionType: '',
    })

  const [detailsLoading, setDetailsLoading] = useState(false)
  const [detailsError, setDetailsError] = useState(false)

  const getTransactionDetails = async (
    transactionId: string,
  ): Promise<void> => {
    try {
      setDetailsLoading(true)
      const response = await fetchTransactionDetails(transactionId)
      setTransactionDetail(response)
    } catch (error) {
      setDetailsError(true)
    } finally {
      setDetailsLoading(false)
    }
  }
  return {
    detailsLoading,
    detailsError,
    transactionDetail,
    getTransactionDetails,
  }
}
